import React from 'react';
import PropTypes from 'prop-types';
import { classes as c } from 'stylesheet';

const defaultColor = variant => {
  switch (variant) {
    case 'headline':
    case 'heavyHeadline':
      return 'razzmatazz';
    case 'gearBacking':
      return 'blackberry';
    case 'shareDesc':
      return 'slate';
    case 'countdownNumber':
    case 'shareCount':
    case 'countdownLetter':
    default: return 'white';
  }
}

const Text = (props) => {
  let { variant, style, children, color, classes } = props;
  let combined = `${c[color || defaultColor(variant)]} ${classes} ${c[variant]}`;
  switch (variant) {
    case 'h1':
    case 'gearBacking':
      return <h1 style={style} className={combined} ref={props.textRef}>{children}</h1>;
    default: return <p style={style} className={combined} ref={props.textRef}>{children}</p>;
  }
};

Text.propTypes = {
  children: PropTypes.string,
  variant: PropTypes.string,
  style: PropTypes.object,
  classes: PropTypes.string,
  textRef: PropTypes.func
}

Text.defaultProps = {
  style: {},
  variant: 'p',
  children: '',
  classes: '',
  textRef: f => f,
}

export default Text;



// WEBPACK FOOTER //
// ./src/components/Text.js